module.exports = __webpack_public_path__ + "static/media/ntiaabuja.090ec60d.JPG";